import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import sablonok from './views/sablonok.vue'
import csoportok from './views/csoportok.vue'
import csoportkezelese from './views/csoportkezelese.vue'
import csoporteredmenybevitel from './views/csoporteredmenybevitel.vue'
import csoportgyakorlatok from './views/csoportgyakorlatok.vue'
import csoportjegyek from './views/csoportjegyek.vue'
import csoportdiagramok from './views/csoportdiagramok.vue'

import admin from './views/admin.vue';
import bejelentkezes from './views/bejelentkezes.vue'
import profil from './views/profil.vue'
import store from './store.js'
Vue.use(Router)


const router =  new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/about',
      name: 'about',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ './views/About.vue')
    },
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/bejelentkezes',
      name: 'bejelentkezes',
      component: bejelentkezes
    },
    {
      path: '/admin',
      name: 'admin',
      component: admin,
      meta: {bejelentkezesszukseges: true, adminjogszukseges: true}
    },
    {
      path: '/sablonok',
      name: 'sablonok',
      component: sablonok,
      meta: {bejelentkezesszukseges: true, adminjogszukseges: true}
    },
    {
      path: '/csoportok',
      name: 'csoportok',
      component: csoportok,
      meta: {bejelentkezesszukseges: true}
    },
    {
      path: '/csoportkezelese/:id',
      name: 'csoportkezelese',
      component: csoportkezelese,
      props: true,
      meta: {bejelentkezesszukseges: true}
    },
    {
      path: '/csoportgyakorlatok/:id',
      name: 'csoportgyakorlatok',
      component: csoportgyakorlatok,
      props: true,
      meta: {bejelentkezesszukseges: true}
    },
    {
      path: '/csoporteredmenybevitel/:id',
      name: 'csoporteredmenybevitel',
      component: csoporteredmenybevitel,
      props: true,
      meta: {bejelentkezesszukseges: true}
    },
    {
      path: '/csoportjegyek/:id',
      name: 'csoportjegyek',
      component: csoportjegyek,
      props: true,
      meta: {bejelentkezesszukseges: true}
    },
    {
      path: '/csoportdiagramok/:id',
      name: 'csoportdiagramok',
      component: csoportdiagramok,
      props: true,
      meta: {bejelentkezesszukseges: true}
    },
    {
      path: '/profil',
      name: 'profil',
      component: profil,
      meta: {bejelentkezesszukseges: true}
    }
  ]
})
router.beforeEach((to, from, next) => {

    if(to.meta.bejelentkezesszukseges){
      if(store.state.bejelentkezve){
        if(to.meta.adminjogszukseges){
          if(store.state.admin){
            next();
          }
          else{
            next('/');
          }
        }
        else{
          next();
        }
      }
      else{
        next('/');
      }
    }
    else{
      next();
    }

})
export default router;
